import { createReducer, on } from '@ngrx/store';
import { AuthActions } from '../auth/auth.actions';
import { HotelInformationActions } from './hotel-information.actions';
import {
  HotelInformationState,
  initialHotelInformationState,
} from './hotel-information.state';

export const hotelInformationReducer = createReducer(
  initialHotelInformationState,
  on(
    HotelInformationActions.load,
    (state): HotelInformationState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    HotelInformationActions.loadSuccess,
    (state, { hotelInformation }): HotelInformationState => ({
      data: hotelInformation,
      loading: false,
      error: null,
    }),
  ),
  on(
    HotelInformationActions.loadFailure,
    (state, { error }): HotelInformationState => ({
      ...state,
      loading: false,
      error,
    }),
  ),
  on(
    HotelInformationActions.clear,
    AuthActions.loginSuccess,
    AuthActions.tokenLoginSuccess,
    AuthActions.changeHotelSuccess,
    AuthActions.logout,
    (): HotelInformationState => initialHotelInformationState,
  ),
);
